(function() {
  angular.module('cfn').controller('stockyardCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'Stockyard',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      CoreREST,
      Stockyard,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter
    ) {
      var mode = {
        name: 'stockyard'
      };

      var ctrl = this;
      ctrl.getEntityName = function() {
        try {
          return $scope.details.stockyard.name;
        } catch (e) {
          return '';
        }
      };

      // validation engine
      var vgi = {};
      vgi['name'] = '1';
      vgi['inventory'] = '1';
      mode.vgi = vgi;

      return coreCommonController(
        'stockyard',
        ctrl,
        mode,
        $scope,
        $rootScope,
        CoreREST,
        Stockyard,
        $http,
        $timeout,
        $log,
        $dialog,
        $injector,
        $route,
        FavoriteService,
        i18nFilter
      );
    }
  ]);
})();
